<template>
  <div class="IInfoListItem">
    <div class="IInfoListItemTitle">
      <template v-if="$slots.title">
        <slot name="title" />
      </template>
      <template v-else>
        {{ title }}
      </template>
    </div>
    <div class="IInfoListItemValue">
      <template v-if="$slots.value">
        <slot name="value" />
      </template>
      <template v-else>
        {{ value }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.IInfoListItem {
  @apply tw-py-3 tw-text-base tw-flex tw-tracking-normal;

  &:not(:last-child) {
    @apply tw-border-b tw-border-gray;
    @apply dark:tw-border-dm-gray;
  }

  &Title {
    @apply tw-w-40 tw-mr-4 tw-text-gray-dark tw-flex-shrink-0;
    @apply dark:tw-text-dm-gray-dark;
  }

  &Value {
    @apply tw-text-dark;
    @apply dark:tw-text-dm-dark;
  }
}
</style>
